<mat-card class="mat-elevation-z0 mat_card_general_content">
  <h2>Generar link de entrega/devolución</h2>
  <form>
    <div class="row mb-3">
      <div class="col-md-4">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Rut trabajador</mat-label>
          <input type="text" matInput required name="form.rut" [(ngModel)]="form.rut"
                 (input)="onRutInput($event)" placeholder="Ej: 12.345.678-9" />
        </mat-form-field>
        <div *ngIf="sugerenciasTrabajador.length > 0" class="list-group sugerencias-trabajador">
          <button type="button" class="list-group-item list-group-item-action" *ngFor="let t of sugerenciasTrabajador"
                  (click)="seleccionarTrabajador(t)">
            {{ t.rut | formatoRut }} - {{ t.nombres }} {{ t.apellidos }}
          </button>
        </div>
        <button mat-stroked-button color="primary" type="button" [disabled]="buscandoTrabajador" (click)="buscarTrabajadorPorRut()">
          <mat-icon>search</mat-icon>
          Buscar
        </button>
        <div *ngIf="trabajadorBuscado" class="mt-1">
          <span *ngIf="trabajadorEncontrado" class="text-success">
            Trabajador existente: {{ trabajadorEncontrado.nombres }} {{ trabajadorEncontrado.apellidos }}
          </span>
          <span *ngIf="!trabajadorEncontrado" class="text-muted">
            No encontrado, se tratará como trabajador nuevo.
          </span>
        </div>
      </div>
      <div class="col-md-3 d-flex align-items-center">
        <mat-checkbox name="form.esExtranjero" [(ngModel)]="form.esExtranjero">Es extranjero</mat-checkbox>
      </div>
      <div class="col-md-5">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Tipo de movimiento</mat-label>
          <mat-select name="form.tipoMovimiento" [(ngModel)]="form.tipoMovimiento" required
                      (selectionChange)="onTipoMovimientoChange()">
            <mat-option *ngFor="let tipo of tiposMovimiento" [value]="tipo">{{ tipo }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row mb-3" *ngIf="requiereSeleccionRestringida">
      <div class="col-md-8">
        <mat-hint *ngIf="!trabajadorEncontrado" class="text-muted d-block">
          Busca primero al trabajador (arriba) para elegir qué equipo activo se devuelve.
        </mat-hint>
        <div *ngIf="trabajadorEncontrado && equiposActivosDelTrabajador.length === 0" class="text-muted">
          Este trabajador no tiene equipos activos para devolver.
        </div>
        <div *ngIf="equiposActivosDelTrabajador.length > 0">
          <mat-label>{{ form.tipoMovimiento === 'REEMPLAZO' ? 'Equipo que se devuelve (reemplazo)' : 'Equipo que se devuelve' }}</mat-label>
          <div class="list-group">
            <button type="button" class="list-group-item list-group-item-action"
                    *ngFor="let eq of equiposActivosDelTrabajador"
                    [class.active]="esEquipoActivoSeleccionado(eq)"
                    (click)="form.tipoMovimiento === 'REEMPLAZO' ? seleccionarEquipoAnterior(eq) : seleccionarEquipoParaDevolver(eq)">
              {{ eq.EquipoTecnologico?.tipo }} - {{ eq.EquipoTecnologico?.marca }} {{ eq.EquipoTecnologico?.modelo }}
              (S/N: {{ eq.EquipoTecnologico?.numeroSerie }})
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6" *ngIf="form.tipoMovimiento !== 'DEVOLUCION'">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>{{ form.tipoMovimiento === 'REEMPLAZO' ? 'Buscar equipo nuevo del catálogo' : 'Buscar equipo del catálogo (opcional)' }}</mat-label>
          <input type="text" matInput [(ngModel)]="textoBusquedaEquipo" name="textoBusquedaEquipo"
                 (input)="onBuscarEquipo($event)" placeholder="Buscar por modelo o número de serie" />
        </mat-form-field>
        <div *ngIf="equiposEncontrados.length > 0" class="list-group equipos-sugeridos">
          <button type="button" class="list-group-item list-group-item-action" *ngFor="let eq of equiposEncontrados"
                  (click)="seleccionarEquipo(eq)">
            {{ eq.tipo }} - {{ eq.marca }} {{ eq.modelo }} (S/N: {{ eq.numeroSerie }})
          </button>
        </div>
        <div *ngIf="equipoSeleccionado" class="mt-2">
          <mat-chip-list>
            <mat-chip color="primary" selected (removed)="quitarEquipoSeleccionado()">
              {{ equipoSeleccionado.tipo }} - {{ equipoSeleccionado.marca }} {{ equipoSeleccionado.modelo }} (S/N: {{ equipoSeleccionado.numeroSerie }})
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <mat-hint *ngIf="!equipoSeleccionado">Si se deja vacío, quien firme el link deberá ingresar los datos del equipo.</mat-hint>
      </div>
      <div class="col-md-6">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Observación</mat-label>
          <input type="text" maxlength="255" matInput name="form.observacion" [(ngModel)]="form.observacion" placeholder="Opcional" />
        </mat-form-field>
      </div>
    </div>

    <hr class="my-3" />

    <!-- Oculto: pantalla muy cargada. Se deja comentado (no eliminado) por si se necesita reactivar. -->
    <!--
    <div class="row mb-2">
      <div class="col-12">
        <mat-checkbox [(ngModel)]="esDocumentoManual" name="esDocumentoManual"
                      (ngModelChange)="esDocumentoManual && (esRegistroForzado = false)">
          Ya está firmado en papel (solo subir el respaldo escaneado)
        </mat-checkbox>
      </div>
    </div>

    <div class="row mb-3" *ngIf="esDocumentoManual">
      <div class="col-12">
        <input type="file" (change)="onHojaFisicaSeleccionada($event)" accept="image/*,.pdf" />
        <mat-hint class="d-block">Adjunta la foto o escaneo del documento ya firmado en papel.</mat-hint>
      </div>
    </div>
    -->

    <div class="row mb-2">
      <div class="col-12">
        <mat-checkbox [(ngModel)]="esRegistroForzado" name="esRegistroForzado"
                      (ngModelChange)="esRegistroForzado && (esDocumentoManual = false)">
          El trabajador se negó a firmar (registrar de todas formas dejando constancia del motivo)
        </mat-checkbox>
      </div>
    </div>

    <div class="row mb-3" *ngIf="esRegistroForzado">
      <div class="col-12">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Motivo por el que no hay firma</mat-label>
          <textarea matInput maxlength="200" [(ngModel)]="motivoSinFirma" name="motivoSinFirma"
                    placeholder="Ej: trabajador se retira en desacuerdo y se niega a firmar"></textarea>
        </mat-form-field>
        <mat-hint class="d-block text-muted">
          Debes seleccionar el equipo del catálogo (arriba). Este movimiento queda registrado sin firma ni documento físico.
        </mat-hint>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12 text-end">
        <button *ngIf="!esDocumentoManual && !esRegistroForzado" mat-raised-button color="primary" type="button" [disabled]="generando" (click)="generarLink()">
          <mat-icon>link</mat-icon>
          Generar link
        </button>
        <button *ngIf="esDocumentoManual" mat-raised-button color="primary" type="button" [disabled]="registrandoManual" (click)="registrarManual()">
          <mat-icon>upload_file</mat-icon>
          Registrar documento firmado
        </button>
        <button *ngIf="esRegistroForzado" mat-raised-button color="warn" type="button" [disabled]="registrandoForzado" (click)="registrarForzado()">
          <mat-icon>edit_off</mat-icon>
          Registrar sin firma
        </button>
      </div>
    </div>
  </form>

  <div class="row mt-3" *ngIf="linkGenerado">
    <div class="col-12">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Link generado</mat-label>
        <input type="text" matInput readonly [value]="linkGenerado" />
      </mat-form-field>
      <button mat-stroked-button color="primary" type="button" (click)="copiarLink()">
        <mat-icon>content_copy</mat-icon>
        Copiar link
      </button>
    </div>
  </div>
</mat-card>
